<template>
  <div
    :class="{
      'f-progress-bar': true,
      'is-complete': progress === Number(100)
    }">
    <div class="f-progress-bar-line">
      <div class="f-progress-bar-line-completion" :style="'width: ' + progress + '%;'">
      </div>
    </div>
    <div class="f-progress-bar-value">{{ progress }}%</div>
  </div>
</template>
<script>

export default {
  name: 'f-progress-bar',
  props: {
    progress: {
      type: Number,
      default: 0
    }
  }
}
</script>
